import React, { useEffect, useRef, useState } from "react";
import styles from "./style.module.scss";
import cx from "classnames";

import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginGetFile from 'filepond-plugin-get-file';
import FilePondPluginPdfPreview from "filepond-plugin-pdf-preview";
import FilePondPluginPdfConvert from "filepond-plugin-pdf-convert";
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css';

import { getUrl as getS3AssetURL } from 'aws-amplify/storage';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginGetFile,
  FilePondPluginPdfPreview
);

const FileUploadInput = (props) => {
  const { onUpdateFiles, allowMultiple = false, onChange,
    maxFiles = 3, name = "files", files, disabled = false,
    label = "Arrastre los documentos en esta area",
    convertPdfToImage = false, resize = false, customProps = {},
    inputProps = {},
    inputErrors = false
  } = props

  const { inputConfig } = inputProps;
  const inputLabel = `${label} <span class="filepond--label-action"> o Selecione un  Documentos</span>`;
  const [inputFiles, setInputFiles] = useState([]);
  const [deletedAsset, setDeletedAsset] = useState({});
  const stateRef = useRef();
  stateRef.current = deletedAsset;

  if (convertPdfToImage) {
    registerPlugin(FilePondPluginPdfConvert);
  }
  if (resize) {
    registerPlugin(FilePondPluginImageResize);
  }

  useEffect(() => {
    if (files) {
      parseFiles(files);
    }
  }, [files]);

  const parseFiles = (files) => {
    if (files.length === 0) {
      setInputFiles([]);
    } else {
      const parsedFiles = files.filter(f => !f._toDelete).map((f) => {
        if (f.filePondData) {
          return f.filePondData;
        } else if (f.id) {
          return {
            source: f.path,
            options: {
              type: 'local',
              metadata: {
                assetId: f.id,
              },
            }
          };
        }
      });
      setInputFiles(parsedFiles);
    }
  }

  const onRemove = (error, file) => {
    const { assetId } = file.getMetadata();
    if (assetId) {
      const newDeletedAsset = {
        ...deletedAsset,
        [assetId]: {
          id: assetId,
          _toDelete: true,
          path: file.source
        }
      };
      setDeletedAsset(newDeletedAsset);
    }

  }

  const onUpdate = (files) => {
    const assetFiles = files.map((f) => {
      const { assetId } = f.getMetadata();
      return {
        id: assetId,
        name: f.file.name,
        type: f.file.type,
        size: f.file.size,
        data: f.file,
        filePondData: f
      }
    });
    const deletedFiles = Object.keys(stateRef.current).map(k => stateRef.current[k]);

    if (onUpdateFiles) {
      onUpdateFiles([...assetFiles, ...deletedFiles]);
    }
    if (onChange) {
      onChange(
        {
          [name]: [...assetFiles, ...deletedFiles]
        }
      );
    }
    setInputFiles(files);
  }

  const filePondS3Server = () => {
    return {
      load: (src, load) => {
        getS3AssetURL({
          path: src,
        }).then((signedURL) => fetch(signedURL.url))
          .then(res => res.blob())
          .then(load);
      }
    }
  }
  return (
    <>
      <div className={cx(
        {
          [styles.fileUpload]: true,
          "is-invalid form-control": inputErrors,
          [styles.errorPadding]: inputErrors,
        }
      )}>
        <FilePond
          disabled={disabled}
          files={inputFiles}
          onupdatefiles={(f) => onUpdate(f)}
          onremovefile={(error, file) => onRemove(error, file)}
          allowMultiple={allowMultiple}
          maxFiles={maxFiles}
          server={filePondS3Server()}
          name={name}
          credits={false}
          instantUpload={false}
          labelIdle={inputLabel}
          pdfComponentExtraParams="toolbar=1"
          labelButtonDownloadItem="Descargar"
          allowDownloadByUrl={true}
          {...inputConfig}
          {...customProps}
        />
      </div>
      {inputErrors}
    </>
  );
}

export default FileUploadInput;